export function resetChildItemsStatuses(item) {
  item.childItemsActive = false;
  item.directChildItemsActive = false;
  item.childItemsThemeWordsActive = false;
  item.directChildItemsThemeWordsActive = false;
  if (item.items) {
    for (let childItem of item.items) {
      resetChildItemsStatuses(childItem);
    }
  }
}

/**
 * Compare state and item themeword statuses and update if necessary
 * @param {Object} themeWords 
 * @param {Object} item 
 * @param {Array} parentItems 
 */
export function changeThemeWordsStateRecursive(themeWords, item, parentItems = []) {

    let currentThemeWords = item.themeWords;

    // True if any of themewords had matches
    item.themeWordsActive = setThemeWordStatuses(currentThemeWords, themeWords);

    // Deconstruct parentItems into new array (new array, not a reference to existing one)
    let parentItemsArray = [...parentItems];

    // If item is current (main item, 1 per view) or activeItem (subItem, possibly multiple per view)
    // set information and e.g. allow childItemsActive status to be set to correct parent element
    // Repeat for themeword statuses
    setChildItemsStatuses(item, parentItemsArray);
    
    parentItemsArray.push(item);
    
    // If item has child items, go through them recursively
    if (item.items) {
      for (let childItem of item.items) {
        changeThemeWordsStateRecursive(themeWords, childItem, parentItemsArray);
      }
    }

};

/**
 * Helper, set every parent items childItemsActive to true if current item has themewords
 * @param {Boolean} childItemActive 
 * @param {Array} parentItemsArray 
 */
 function setChildItemsStatuses(childItem, parentItemsArray) {
  parentItemsArray.forEach((parentItem, index, parentItemsArray) => {

    // Add info about active status (current items and its childs)
    if (childItem.currentItem || childItem.activeItem) {
      parentItem.childItemsActive = true;

      // Check for closest parent and set state info of active themewords in direct child
      if (index === parentItemsArray.length - 1) {
        parentItem.directChildItemsActive = true;
      }
    }

    // Add info about themeWord statuses
    if (childItem.themeWordsActive) {
      parentItem.childItemsThemeWordsActive = true;

      if (index === parentItemsArray.length - 1) {
        parentItem.directChildItemsThemeWordsActive = true;
      }
    }
  });
}

/**
 * Helper, compare values between old and new states, change to new themeword's value if necessary
 * @param {Object} currentThemeWords to be changed
 * @param {Object} themeWords in state
 */
function setThemeWordStatuses(currentThemeWords, themeWords) {
  let themeWordsActive = false;
  for (let name in currentThemeWords) {

    if (currentThemeWords[name] !== themeWords[name]) {
      currentThemeWords[name] = themeWords[name];        
    }

    if (currentThemeWords[name]) themeWordsActive = true;
  }
  return themeWordsActive;
}

/**
 * Extracts url into matches
 * @param {String} path url
 * @returns array of matches, e.g. ...#/2/4? --> ["2","4"]
 */
export function getLocationDataArray(path) {
  // NOTE: below does not work on Safari (lookbehind regex)
  // let regexpPath = /(?<=\/)[0-9]+/g

  let regexpPath = /\/[a-z0-9]+/g;
  let matchesArray = ["0"];

  // Check if path has dash, then dont do match, which removes everything dash and text after dash
  // else split URL
  if (path.includes('-')) {
    let strPath = path.replace("/","");
    matchesArray.push(strPath);
  } else {
    let matches  = path.match(regexpPath);

    // default match
    if (matches) { // Only run if url matches has content

      // Remove / characters from each match
       matches.map(match => {
         let cleanedMatch = match.replace("/", "");
         matchesArray.push(cleanedMatch)
       });
    }
  }
  return matchesArray;
}

export function getContentObjects(intMatches, item, resultsArray, getMultiple, skipContentIds = []) {
  let arraysEqual = false;
  let arrayIncluded = false;
  if (getMultiple) {
    arrayIncluded = isArrayIncluded(intMatches, item.locationData);
  } else {
    arraysEqual = areArraysEqual(intMatches, item.locationData);
  }
  // If arrays are Equal or included in locationData when requesting multiple web contents,
  // add item to resultsArray
  if (arraysEqual || arrayIncluded) {

    if (!skipContentIds.includes(item.contentId)) {
      resultsArray.push(item);
    }

    // Check if item has infoItem-items (items not numbered in navigation), 
    // add item to resultsArray
    if (item.infoItems && item.infoItems.length) {

      item.infoItems.forEach(singleInfoItem => {
        if (!skipContentIds.includes(singleInfoItem.contentId)) {
          resultsArray.push(singleInfoItem);
        }
      });

    }
  }

  // Stop execution if only single content is requested and it has been found (in resultsArray)
  if (getMultiple || (!getMultiple && !resultsArray.length)) {
    if (item.items && item.items.length ) {
      for (let childItem of item.items) {
        getContentObjects(intMatches, childItem, resultsArray, getMultiple, skipContentIds);
      }
    }
  }  
}

export function areArraysEqual(array1, array2) {

  if (typeof array1 === 'undefined') array1 = [0];
  if (typeof array2 === 'undefined') array2 = [0];

  return array1.length === array2.length &&
  array1.every(function (element, index) {
    return element === array2[index];
  });
}

export function isArrayIncluded(array1, array2) {

  // Remove 0 from end of array, allowing direct array comparisons
  const comparisonArray = [...array1];
  comparisonArray.pop();
  if (typeof array1 === 'undefined') array1 = [0];
  if (typeof array2 === 'undefined') array2 = [0];

  // Check if comparisonArray is included in the item.locationData array
  // E.g. [ 0, 1, 0 ] will match itself and [ 0, 1, 0, 1 ] but not [ 0, 1, 1 ]
  for (let i = 0; i < comparisonArray.length; i++) {
    if (comparisonArray[i] !== array2[i]) {
      return false;
    }
  }
  return true;
}

export function modifyPathStringWithParameters(themeWords, pathString) {

  let modifiedPathString = pathString;

  // Get themeWords that are active and insert them into path string
  let activeThemewords = Object.keys(themeWords).filter(key => themeWords[key] === true);

  for (let i = 0; i < activeThemewords.length; i++) {
    if (i === 0) { // first query parameter
      modifiedPathString += "?themeword=" + activeThemewords[i].toLowerCase();
    } else { // following query parameters
      modifiedPathString += "&themeword=" + activeThemewords[i].toLowerCase();
    }
  }

  return modifiedPathString;
}

function urlReplace (replacements, str) {
  let result = str;
  for (let [x, y] of replacements) {
    result = result.replace(x, y);
  }

  return result;
}
export function createUrlString(string) {

  let urlString = string.toLowerCase();
  if (urlString) {        
    let output = urlReplace([
      [/[!"#$%&'()*+,./\\–]/g,''], // replace specified special characters with empty
      [/\s/g,'-'], // replace whitespaces with '-'
      [/å/g, 'a'],
      [/ä/g, 'a'],
      [/ö/g, 'o'],
    ], urlString);
    urlString = output;
  }

  return urlString;
}

/**
 * Helper, turn location arrays into HTML-compliant format e.g. e.g. [0, 1, 0] --> 1-0
 * @param { Array } locationData 
 * @returns String, the number as a string or empty string
 */
export function getIdFromLocationData(locationData) {
  let result = "";
  if (locationData) {  
    for (let i = 1; i < locationData.length; i++) {
      if (result) {
        result += "-" + (locationData[i]);
      } else {
        result += locationData[i];
      }
    }
  }
  return result;
}

/**
 * @description Helper, turn location data arrays into readable format e.g. [0, 1, 0] --> 1.0 
 * @param { Array } locationData 
 * @returns String, the number as a string or empty string
 */
export function formattedLocationData(locationData) {
  let value = "";
  if (locationData) {    
    for (let i = 1; i < locationData.length; i++) {
      if (value) {
        value += "." + (locationData[i]);
      } else {
        value += locationData[i];
      }
    }
  }
    return value;
}

/**
 * @description Helper, turn name into usable id by replacing characters
 * @param { String } name
 * @returns String
 */

export const getIdFromItemName = (name) => {
  let str = "";
  if (name !== "") {
    str = name
        .toLowerCase()
        .replace(/ä|å/g, "a")
        .replace('ö','o')
        .replace(' ' ,'_')
        .replace(/[^\w\s]/gi, "");
  }
  return str;
}

export const getURLFromItemName = (name) => {
  let str = "";
  if (name !== "") {
    str = name
        .toLowerCase()
        .replace(/ä|å/g, "a")
        .replace(/ö|ø/g, 'o')
        .replace(/\s/g ,'-')
        .replace(/%20/g, "-")
        .replace(',','-')
        .replace(/[!:"#$%&'()*+,./\\–]/g,'')
        .replace('--','-');
  }
  return decodeURI(str);
}